module.exports = __webpack_public_path__ + "img/q-2-1@2x.605600f0.png";